import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-request-changes-dialog',
  templateUrl: './request-changes-dialog.component.html',
  styleUrls: ['./request-changes-dialog.component.scss']
})
export class RequestChangesDialogComponent {
    public readonly form: FormGroup = this.forms.group({
        change: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
    })

    public constructor(
        private readonly forms: FormBuilder,
    ) {
        //
    }
}
